import styled from '@emotion/styled';
import Img03 from 'ui/images/top/kv_simg03@2x.png';

const Wrapper = styled.div`
    width: 80svw;
    padding: 30px 20px;
    max-width: 600px;
    border-radius: 20px;
    background: var(--white);
    margin: 10px auto;
    text-align: center;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

    img {
        width: 160px;
        margin: 0 auto;
    }
`;

const Title = styled.div`
    font-size: var(--font-xx-large);
    font-weight: 600;
    margin-bottom: 10px;
    line-height: 1.5;
`;

const Descriptions = styled.div`
    text-align: center;
    gap: 5px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
`;

const Section = styled.div`
    margin: 15px 0;
    text-align: left;
`;

const SectionTitle = styled.h3`
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    margin-bottom: 5px;
    color: var(--primary);
`;

const SectionContent = styled.div`
    font-size: var(--font-large);
    line-height: 1.6;
`;

const Link = styled.a`
    color: var(--primary);
    text-decoration: underline;
    word-break: break-all;
`;

const SubmitButton = styled.button`
    background-color: var(--primary);
    color: var(--white);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    padding: 15px 25px;
    border-radius: 25px;
    cursor: pointer;
    margin: 5px auto 0 auto;
    border: none;
    outline: none;
`;

const Emphasis = styled.span`
    color: var(--primary);
    font-weight: var(--font-bold);
    font-size: var(--font-x-large);
`;

interface Props {
    onClick: () => void;
}

/**
 * 補助金サポートについて
 */
export const SubsidyInfo: React.FC<Props> = ({ onClick }) => {
    return (
        <Wrapper>
            <Title>事業承継・M&A補助金のサポートを受けませんか？</Title>
            <Descriptions>
                <img src={Img03} alt="挿絵" />
            </Descriptions>

            <Section>
                <SectionContent>
                    M&Aにかかる仲介手数料やDD費用等に対し、買い手、売り手ともに
                    <br />
                    <Emphasis>上限600-800万円</Emphasis>
                    を受け取れる補助金です。
                    <br />
                    <br />
                    <Emphasis>お相手が見つかっていなくても採択を受けられる</Emphasis>
                    ため、M&Aを検討する場合、早めの申請がおすすめです。
                </SectionContent>
            </Section>

            <Section>
                <SectionTitle>【事業承継・引継ぎ補助金 公式サイト】</SectionTitle>
                <SectionContent>
                    <Link href="https://jsh.go.jp/r6h/" target="_blank" rel="noopener noreferrer">
                        {'https://jsh.go.jp/r6h/'}
                    </Link>
                    <br />
                    <br />
                    ※申請を行うと、後日提携先の補助金支援企業からメールが届きます。
                </SectionContent>
            </Section>

            <SubmitButton onClick={onClick}>補助金申請のサポートを受ける</SubmitButton>
        </Wrapper>
    );
};
